<ng-template #preHeader>
    BECOME A MEMBER
</ng-template>
<shared-auth-header [preHeader]="preHeader" [description]="description">
    Complete your profile
</shared-auth-header>
<ng-template #description>
    Add a password to your profile so you can sign in to view favourite orders for fast re-ordering next visit.
</ng-template>

<shared-form-for-link-rewards-account-password labelSubmit="Create account" [modal]="true">
</shared-form-for-link-rewards-account-password>